var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var baseClass = "rj-message";
export var MessageStates;
(function (MessageStates) {
    MessageStates["info"] = "rj-message--info";
    MessageStates["error"] = "rj-message--error";
    MessageStates["warning"] = "rj-message--warning";
})(MessageStates || (MessageStates = {}));
var Message = /** @class */ (function (_super) {
    __extends(Message, _super);
    function Message() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Message.prototype.render = function () {
        var cls = baseClass + " " + (this.props.type || MessageStates.info);
        /* istanbul ignore next */
        return (React.createElement("div", { className: cls }, this.props.text || this.props.children));
    };
    return Message;
}(React.Component));
export { Message };
//# sourceMappingURL=Message.js.map